export default "__VITE_ASSET__C9Ha4Av2__"